// extracted by mini-css-extract-plugin
module.exports = {"root":"FFg4y","iframeHolder":"_1WP0F","iframe":"_3Xz9Z"};